import React, { useRef, useEffect } from "react";
import styled from "styled-components";
import { Flex } from "rebass/styled-components";

const Modal = styled(Flex)``;

export default function ({
  isModalOpen,
  setModalOpen,
  children,
  handleModalClose,
  disableOutsideClose,
  ...props
}) {
  const node = useRef();
  const handleClick = ({ target }) => {
    if (node.current && node.current.isSameNode(target)) {
      if (disableOutsideClose) return;
      if (handleModalClose) handleModalClose();
      return setModalOpen(false);
    }
  };

  useEffect(() => {
    if (node.current) {
      node.current.addEventListener("click", handleClick);
      // return () => {
      //   node.current.removeEventListener('click', handleClick);
      // };
    }
  });
  return isModalOpen ? (
    <Modal
      variant="modal"
      ref={node}
      key={`modal-${node}`}
      style={{ display: isModalOpen ? "flex" : "none" }}
      {...props}
    >
      {children}
    </Modal>
  ) : (
    <></>
  );
}
